const predicate = process.env.NODE_ENV === 'development'

export default function(dev, prod) {
    return predicate ? dev : prod
}
